import type { FilterDef, FilterValue } from "@/lib/table"

import type { ClientFilters } from "./clients-data"

export function buildClientsFilterSchema(): FilterDef[] {
  return [
    {
      id: "status",
      label: "Status",
      kind: "select",
      options: [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
      ],
      placeholder: "Any status",
    },
    {
      id: "hasPrimary",
      label: "Primary Client Contact",
      kind: "select",
      options: [
        { value: "assigned", label: "Assigned" },
        { value: "missing", label: "Missing" },
      ],
      placeholder: "Any",
    },
    { id: "createdAt", label: "Created", kind: "date-range" },
  ]
}

type ClientFilterValues = Partial<Record<"status" | "hasPrimary" | "createdAt", FilterValue>>

export function filtersToQuery(values: ClientFilterValues): ClientFilters {
  const q: ClientFilters = {}

  if (values.status === "active" || values.status === "inactive") {
    q.status = values.status
  }

  if (values.hasPrimary === "assigned") q.hasPrimary = true
  else if (values.hasPrimary === "missing") q.hasPrimary = false

  if (
    values.createdAt &&
    typeof values.createdAt === "object" &&
    !Array.isArray(values.createdAt) &&
    "from" in values.createdAt
  ) {
    const r = values.createdAt as { from: string | null; to: string | null }
    if (r.from || r.to) q.createdAt = r
  }

  return q
}
